export const iconFontAwesomeReligionVihara = (
	<i className="fa-solid fa-vihara"></i>
);
